module.exports = "<div class='wrapper closed'>\n  <app-top-panel></app-top-panel>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/budget/wrapper/wrapper.component.html
// module id = ./src/app/components/budget/wrapper/wrapper.component.html
// module chunks = main